

import { connect } from "react-redux";
import * as TranslationsActions from "../actions/translationsActions";
import * as ActionCreators from "../actions/actionCreators";
import * as CommentsActions from "../actions/commentsActions";
import CommentComponent from "../components/comments/commentComponent";

const mapStateToProps = state => ({
    translations: state.translations,
    locale: state.locale,
    comment: state.comment,
    tempComment: state.tempComment,
    spinnerDisplay: state.spinnerDisplay,
    error: state.error,
    bannedWordError: state.bannedWordError,
    modalOnDisplay: state.modalOnDisplay,
    previewToggle: state.previewToggle,
    imageLoading: state.imageLoading,
    uploadedImages: state.uploadedImages,
    privacyPolicyLink: state.privacyPolicyLink,
    commentsInfoReceived: state.commentsInfoReceived,
    doubleByteExists: state.doubleByteExists,
    emojiExists: state.emojiExists,
  });

const mapDispatchToProps = dispatch => ({
    getTranslations: (locale, fromUpdateLocale) => {
      dispatch(TranslationsActions.getTranslations(locale, fromUpdateLocale));
    },
    updateLocale: () => {
      dispatch(TranslationsActions.updateLocale());
    },
    getUserInfo: (accountInfo, locale) => {
      dispatch(CommentsActions.getUserInfo(accountInfo, locale));
    },
    validateCommentForm: () => {
      dispatch(CommentsActions.validateCommentForm());
    },
    displayModal: name => {
      dispatch(ActionCreators.displayModal(name));
    },
    togglePreview: toggle => {
      dispatch(ActionCreators.togglePreview(toggle));
    },
    uploadImage: (image, event) => {
      dispatch(CommentsActions.uploadImage(image, event));
    },
    submitComment: () => {
      dispatch(CommentsActions.submitComment());
    },
    deleteUploadedPhoto: index => {
      dispatch(ActionCreators.deleteUploadedPhoto(index));
    },
    rotatePhoto: index => {
      dispatch(CommentsActions.rotatePhoto(index));
    },
    addTempUserComment: comment => {
      dispatch(ActionCreators.addTempUserComment(comment));
    },
    addTempUserName: name => {
      dispatch(ActionCreators.addTempUserName(name));
    },
    autoOrientImage: index => {
        dispatch(CommentsActions.autoOrientImage(index));
    }
  });

export default connect(mapStateToProps, mapDispatchToProps)(CommentComponent);
